import TranslationText from '@Components/Utilities/TranslationText';
import { userCreationType } from '@Components/Utilities/SandhillsConstants';
import SetPreferences from '@Components/SSO/SetPreferences';

const MyRegistration = (props) => {
    return (
        <div>
            <h3 className='mobile-hide'>
                <TranslationText tKey='sandhills.tradesites.mvc.accountdetails' />
            </h3>
            <div className='grey-box'>
                <div className='flex-col'>
                    <div className='col col-6'>
                        <h4><TranslationText tKey='sandhills.myregistration' /></h4>
                        <div className='cf'>
                            <div className='form-row'>
                                <span><TranslationText tKey='sandhills.tradepubwebsite.mvc.firstname' /> :</span><br />
                                <span className='input-text'>{props.Firstname}</span>
                            </div>
                            <div className='form-row'>
                                <span><TranslationText tKey='sandhills.tradepubwebsite.mvc.lastname' /> :</span><br />
                                <span className='input-text'>{props.Lastname}</span>
                            </div>
                            <div className='form-row'>
                                <span><TranslationText tKey='sandhills.email' /> :</span><br />
                                <span className='input-text'>{props.Email}</span>
                            </div>
                            {props.CompanyName &&
                                <div className='form-row'>
                                    <span><TranslationText tKey='sandhills.companyname' /> :</span><br />
                                    <span className='input-text'>{props.CompanyName}</span>
                                </div>}
                            {((props.UserCreationTypeID == userCreationType.notAddedByExternalAuth) || (props.UserCreationTypeID == userCreationType.externalAuthAddedWithCleanData)) &&
                                <>
                                    {(props.Address1 || props.City || props.State) &&
                                        <div>
                                            {props.Address1 &&
                                                <div className='form-row'>
                                                    <span><TranslationText tKey='sandhills.mobileapps.ios.physicaladdress' /> :</span><br />
                                                    <span className='input-text'>{props.Address1}</span>
                                                </div>}
                                            {props.City &&
                                                <div className='form-row'>
                                                    <span><TranslationText tKey='sandhills.city' /> :</span><br />
                                                    <span className='input-text'>{props.City}</span>
                                                </div>}
                                            {props.State &&
                                                <div className='form-row'>
                                                    <span><TranslationText tKey='sandhills.stateprovince' /> :</span><br />
                                                    <span className='input-text'>{props.State}</span>
                                                </div>}
                                        </div>}
                                    {(props.PostalCode || props.Country) &&
                                        <div>
                                            {props.PostalCode &&
                                                <div className='form-row'>
                                                    <span><TranslationText tKey='sandhills.tradepubwebsite.mvc.postalcode' /> :</span><br />
                                                    <span className='input-text'>{props.PostalCode}</span>
                                                </div>}
                                            {props.Country &&
                                                <div className='form-row'>
                                                    <span><TranslationText tKey='sandhills.country' /> :</span><br />
                                                    <span className='input-text'>{props.Country}</span>
                                                </div>}
                                        </div>}
                                    {(props.Phone && /\d/.test(props.Phone)) &&
                                        <div>
                                            <div className='form-row'>
                                                <span><TranslationText tKey='sandhills.phone' /> :</span><br />
                                                <span className='input-text'>{props.Phone}</span>
                                            </div>
                                        </div>}
                                </>}
                        </div>
                        {((props.UserCreationTypeID == userCreationType.externalAuthAddedWithPlaceholderData) || (props.UserCreationTypeID == userCreationType.minimalAuthAddedWithPlaceholderData)) &&
                            <>
                                {(props.Phone && /\d/.test(props.Phone)) &&
                                    <div className='form-row'>
                                        <span><TranslationText tKey='sandhills.phone' /> :</span><br />
                                        <span className='input-text'>{props.Phone}</span>
                                    </div>}
                            </>}
                        <a className='account-button' href={props.MyRegistrationURL}><TranslationText tKey='sandhills.tradepubwebsite.mvc.updateregistration' /></a>
                    </div>
                    <div className='col col-6'>
                        <h4><TranslationText tKey='sandhills.mypassword' /></h4>
                        <div className='cf'>
                            <div className='form-row'>
                                <span><TranslationText tKey='sandhills.password' /> :</span><br />
                                <span className='input-text'>********</span>
                            </div>
                        </div>
                        <a className='account-button' href={props.ChangePasswordURL}><TranslationText tKey='sandhills.tradesites.mvc.updatepassword' /></a>
                    </div>
                </div>
            </div>
            <SetPreferences {...props.UserSettingModel} />
        </div>
    );
};

export default MyRegistration;